import axios from '../utils/axios';

export const createCoverLetter = async (data) => {
	const result = await axios.post('/api/cover-letters', data);
	return result.data.data;
};

export const updateCoverLetter = async (id, data) => {
	const result = await axios.put(`/api/cover-letters/${id}`, data);
	return result.data.data;
};

export const updatePreview = async (id, blob) => {
	const file = new File([blob], `${id}.png`);

	const formData = new FormData();
	formData.append('preview', file);

	await axios.post(`/api/cover-letters/${id}/update-preview`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

export const retrieveCoverLetter = async (id) => {
	const result = await axios.get(`/api/cover-letters/${id}`);

	return result.data.data;
};

export const retrieveCoverLetters = async () => {
	const result = await axios.get('/api/cover-letters');
	return result?.data?.data || [];
};

export const deleteCoverLetters = async (id) => {
	const result = await axios.delete(`/api/cover-letters/${id}`);
	return result?.data?.data || [];
};

export const downloadCoverLetter = async (id) => {
	const result = await axios.get(`/api/cover-letters/${id}/download`);
	return result?.data;
};

export const generateCoverLetter = async (id, params) => {
	const result = await axios.post(`/api/cover-letters/${id}/generate`, params);
	return result?.data;
};

export const regenerateCoverLetter = async (id, params) => {
	const result = await axios.post(`/api/cover-letters/${id}/regenerate`, params);
	return result?.data;
};
